/* eslint-disable import/prefer-default-export */
export const mobileNumber = state => state.getIn(['auth', 'mobileNumber']);
/* eslint-enable import/prefer-default-export */
